import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const TrackJBlue = ({ state, workState, onLabelClick }) => (
	<g id="TrackJBlue" transform="translate(1670.000000, 1168.000000)" className="track">
		<g id="line" transform="translate(-0.000000, 0.000000)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)} strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<line x1="120" y1="0" x2="82.1824004" y2="9.62386126"/>
			<path
				d="M71.7038222,13 L17.5225705,29.4809401 C7.6058325,32.4974294 1.63706477,42.5905236 3.77152439,52.733747 L7.20843987,69.0664062 L7.20843987,69.0664062"/>

			<TrackArrow
				transform="translate(69.068075, 13.992951) rotate(-197.000000) translate(-69.068075, -13.992951) "
				points="73.068075 21.992951 65.068075 13.992951 73.068075 5.99295104"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'TrackJBlue')}
			coords="16.000000, 10.000000"
			text="J"
			size="small"
			textCoordsX="10.2802734"
			textCoordsY="17"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>
	</g>
);

TrackJBlue.propTypes = trackPropTypes;
export default TrackJBlue;
